import React from "react";
import { Box, Chip, Typography } from "@mui/material";

export const ActiveFilterChips = ({ chips }) => {
  if (!chips.length) return null;

  return (
    <Box sx={{ mt: 1.5, mb: 0.5 }}>
      <Typography variant="caption" sx={{ fontWeight: "bold", mb: 0.5, display: "block" }}>
        Active Filters:
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {chips.map((chip) => (
          <Chip
            key={chip.key}
            label={chip.label}
            onDelete={chip.onDelete}
            color="primary"
            variant="outlined"
            size="small"
          />
        ))}
      </Box>
    </Box>
  );
};
